package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.AnimationAst
import top.wcpe.allincore.dsl.ir.model.animation.SpringSpec
import top.wcpe.allincore.dsl.ir.model.animation.UiAnimation
import top.wcpe.allincore.dsl.ir.model.UiBinding
import top.wcpe.allincore.dsl.ir.model.animation.UiKeyframe

/**
 * 把动画 AST 转换为 dsl-ir v3 动画模型。
 */
class AnimationEmitter(
    private val bindings: BindingEmitter = BindingEmitter(),
) {

    fun emit(animation: AnimationAst): UiAnimation = emitNode(animation.node)

    private fun emitNode(node: AnimationAst.Node): UiAnimation {
        return UiAnimation(
            toIrKind(node.kind),
            node.durationMs ?: 0.0,
            node.delayMs ?: 0.0,
            node.staggerMs ?: 0.0,
            node.easing ?: "linear",
            emitProps(node.props),
            node.keyframes.map { emitKeyframe(it) },
            node.children.map { emitNode(it) },
            node.loopMode,
            emitSpring(node.spring),
        )
    }

    /** 把弹簧子块 AST 转换为 [SpringSpec]：缺省参数填默认值；无 spring 子块时返回 null（用 easing 驱动）。 */
    private fun emitSpring(spring: AnimationAst.SpringAst?): SpringSpec? {
        if (spring == null) {
            return null
        }
        return SpringSpec(
            spring.stiffness ?: SpringSpec.DEFAULT_STIFFNESS,
            spring.damping ?: SpringSpec.DEFAULT_DAMPING,
            spring.mass ?: SpringSpec.DEFAULT_MASS,
            spring.initialVelocity ?: SpringSpec.DEFAULT_INITIAL_VELOCITY,
        )
    }

    private fun emitKeyframe(keyframe: AnimationAst.Keyframe): UiKeyframe =
        UiKeyframe(keyframe.offset, emitProps(keyframe.props))

    private fun emitProps(props: List<AnimationAst.PropAssign>): Map<String, UiBinding> {
        val out = LinkedHashMap<String, UiBinding>()
        for (prop in props) {
            out[prop.name] = bindings.emit(prop.value)
        }
        return out
    }

    private fun toIrKind(kind: AnimationAst.Kind): UiAnimation.Kind = when (kind) {
        AnimationAst.Kind.TRANSITION -> UiAnimation.Kind.TRANSITION
        AnimationAst.Kind.KEYFRAME -> UiAnimation.Kind.KEYFRAME
        AnimationAst.Kind.SEQUENCE -> UiAnimation.Kind.SEQUENCE
        AnimationAst.Kind.PARALLEL -> UiAnimation.Kind.PARALLEL
        AnimationAst.Kind.STAGGER -> UiAnimation.Kind.STAGGER
        AnimationAst.Kind.PATH_TRANSITION -> UiAnimation.Kind.PATH_TRANSITION
    }
}
